import { UseFormReturn, useWatch } from 'react-hook-form';
import { Box } from '@mui/material';
import Switch from '@shared/components/Switch/SwitchButton';
import { DepositStatus, VisitDetail, VisitForm } from '../../../entity';
import { useUpdateVisitMutation } from '../../../queries';

const DepositStatusSwitch = (props: {
  methods: UseFormReturn<VisitForm>;
  visitDetail: VisitDetail;
}) => {
  const { methods, visitDetail } = props;
  const { control, setValue, getValues } = methods;

  const depositStatus = useWatch({ control, name: 'depositStatus' });

  const { mutate: updateVisit } = useUpdateVisitMutation(
    visitDetail.visit.id,
    visitDetail.client.id,
  );

  const handleChange = (_: unknown, checked: boolean) => {
    const nextStatus = checked ? DepositStatus.ZAPLACENO : DepositStatus.NEZAPLACENO;
    setValue('depositStatus', nextStatus);
    updateVisit(getValues());
  };

  return (
    <Box component="span" onClick={event => event.stopPropagation()}>
      <Switch checked={depositStatus === DepositStatus.ZAPLACENO} onChange={handleChange} />
    </Box>
  );
};

export default DepositStatusSwitch;
